import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import SmartFeedLayout from "%/dynamic-component-editor/options/smart-feed-layout";
import SmartFeedCardLayout from "%/dynamic-component-editor/options/smart-feed-card-layout";

export default class SmartFeedOptions extends BaseOptionsBundle {

  optionTitle = "Smart Feed Options";
  static optionClassName = "i-dynamic-smart-feed-bundle";
  useInspectorLabel = false;

  constructor(values = {}) {
    super(values, [
      SmartFeedLayout,
      SmartFeedCardLayout,
    ]);
  }
}
